module.exports = __webpack_public_path__ + "img/typeOrange.ce9746b4.png";